<template>
  <div class="desig-main">
    <airconditioner v-if="showOne"></airconditioner>
    <refrigeration v-if="showTwo"></refrigeration>
    <sceneshow v-if="showscene"></sceneshow>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import authorityService from '../../service/authorityService'
import Airconditioner from '../../pages/Toolmain/airconditioner'
import Refrigeration from '../../pages/Toolmain/refrigeration'
import Sceneshow from '../../pages/Toolmain/sceneshow'
export default {
  name: '',
  components: {
    collapse: false,
    Airconditioner,
    Refrigeration,
    Sceneshow
  },
  data() {
    return {
      showOne: true,
      showTwo: false,
      showscene: false,
    }
  },
  computed: {
    ...mapState({
      nodeData: 'toolTreeNode',
      addTreeNode: 'addTreeNode',
      updateTreeNode: 'updateTreeNode',
      delTreeNode: 'delTreeNode',
      loginStatus: 'loginStatus'
    })
  },
  watch: {
    nodeData: {
      handler() {
        this.sceneSwitch()
      },
      deep: true
    }
  },
  mounted() {

  },
  methods: {
    // 场景切换
    sceneSwitch() {
      if (this.nodeData.name === '场景1') {
        this.showOne = true
        this.showTwo = false
        this.showscene = false
      }
      if (this.nodeData.name === '场景2') {
        this.showOne = false
        this.showTwo = true
        this.showscene = false
      }
      if (this.nodeData.name === '场景3') {
        this.showOne = false
        this.showTwo = false
        this.showscene = true
      }
    },
    onSubmit() {
      console.log('submit!');
    },
    // 风机段选择
    fanSelect() {
      if (this.fan.length === 0) {
        this.returnAirShow = false
        this.airSupply = false
      }
      if (this.fan.length === 2) {
        this.returnAirShow = true
        this.airSupply = true
      } else {
        if (this.fan[0] === "回风机") {
          this.returnAirShow = true
          this.airSupply = false
        } if (this.fan[0] === "送风机") {
          this.returnAirShow = false
          this.airSupply = true
        }

      }
    },
    // 换热段选择
    heatTran() {
      this.surfaceCool = true
      if (this.heatTransfer.length === 0) {
        this.electricHeat = false
        this.steamCoil = false
        this.hotWater = false
      }
      if (this.heatTransfer.length === 1) {
        this.electricHeat = false
        this.steamCoil = false
        this.hotWater = false
      }
      if (this.heatTransfer.length === 2) {
        if (this.heatTransfer.indexOf("电加热段") > -1) {
          this.electricHeat = true
          this.steamCoil = false
          this.hotWater = false
        }
        if (this.heatTransfer.indexOf("蒸汽盘管段") > -1) {
          this.electricHeat = false
          this.steamCoil = true
          this.hotWater = false
        }
        if (this.heatTransfer.indexOf("热水盘管段") > -1) {
          this.electricHeat = false
          this.steamCoil = false
          this.hotWater = true
        }
      }
      if (this.heatTransfer.length === 3) {
        if (this.heatTransfer.indexOf("电加热段") > -1 && this.heatTransfer.indexOf("蒸汽盘管段") > -1) {
          this.electricHeat = true
          this.steamCoil = true
          this.hotWater = false
        }
        if (this.heatTransfer.indexOf("蒸汽盘管段") > -1 && this.heatTransfer.indexOf("热水盘管段") > -1) {
          this.electricHeat = false
          this.steamCoil = true
          this.hotWater = true
        }
        if (this.heatTransfer.indexOf("热水盘管段") > -1 && this.heatTransfer.indexOf("电加热段") > -1) {
          this.electricHeat = true
          this.steamCoil = false
          this.hotWater = true
        }
      }
      if (this.heatTransfer.length === 4) {
        this.electricHeat = true
        this.steamCoil = true
        this.hotWater = true
      }
    },
    // 加湿段选择
    humidificationSelect() {
      if (this.humidification === 0) {
        this.steamShow = false
        this.membraneShow = false
        this.highpressureShow = false
      }
      if (this.humidification === 3) {
        this.steamShow = true
        this.membraneShow = false
        this.highpressureShow = false
      }
      if (this.humidification === 6) {
        this.steamShow = false
        this.membraneShow = true
        this.highpressureShow = false
      }
      if (this.humidification === 9) {
        this.steamShow = false
        this.membraneShow = false
        this.highpressureShow = true
      }
    },
    // 过滤段选择
    filterSelect() {
      if (this.guolv.length === 0) {
        this.iniFilter = false
        this.mediumFilter = false
        this.effcientFilter = false
      }
      if (this.guolv.length === 1) {
        if (this.guolv[0] === "初效过滤段") {
          this.iniFilter = true
          this.mediumFilter = false
          this.effcientFilter = false
        }
        if (this.guolv[0] === "中效过滤段") {
          this.iniFilter = false
          this.mediumFilter = true
          this.effcientFilter = false
        }
        if (this.guolv[0] === "高效过滤段") {
          this.iniFilter = false
          this.mediumFilter = false
          this.effcientFilter = true
        }
      }
      if (this.guolv.length === 3) {
        this.iniFilter = true
        this.mediumFilter = true
        this.effcientFilter = true
      }
      if (this.guolv.length === 2) {
        if (this.guolv.indexOf("初效过滤段") > -1 && this.guolv.indexOf("中效过滤段") > -1) {
          this.iniFilter = true
          this.mediumFilter = true
          this.effcientFilter = false
        }
        if (this.guolv.indexOf("初效过滤段") > -1 && this.guolv.indexOf("高效过滤段") > -1) {
          this.iniFilter = true
          this.mediumFilter = false
          this.effcientFilter = true
        }
        if (this.guolv.indexOf("中效过滤段") > -1 && this.guolv.indexOf("高效过滤段") > -1) {
          this.iniFilter = false
          this.mediumFilter = true
          this.effcientFilter = true
        }
      }
    },
    // 生成控制方案
    generate() {
      this.tableData = [{
        xuhao: '1',
        name: '送风机',
        model: 'BAC-4KW',
        number: '1',
        parameter: '包含智能仪表、热继、交流接触器、空开、保险等'
      }, {
        xuhao: '2',
        name: '回风机',
        model: 'BACS-4KW',
        number: '1',
        parameter: '包含变频器、空开、保险等'
      }, {
        xuhao: '3',
        name: '湿膜加湿',
        model: 'DN=100',
        number: '1',
        parameter: '根据送风湿度与设定湿度的差值控制加湿阀，达到加湿的效果。'
      }, {
        xuhao: '4',
        name: '新风阀',
        model: '',
        number: '1',
        parameter: '新风阀与送风机联动；根据回风CO2浓度PID调节新风阀开度，保证室内空气新鲜和舒适。'
      }, {
        xuhao: '5',
        name: '回风阀',
        model: '',
        number: '1',
        parameter: '回风阀与新风阀开度互补，保证新风阀开度与回风阀开度的和为100%。'
      }, {
        xuhao: '6',
        name: '排风阀',
        model: '',
        number: '1',
        parameter: '排风阀开度与新风阀开度保持一致，'
      }]
    },
  }
}
</script>
<style scoped>
.desig-main {
  width: 100%;
  height: 100%;
  font-size: 15px;
}

.information-content {
  width: 100%;
  height: 100%;
}

.file-content {
  width: 100%;
}

.tit-content {
  font-size: 1.5vh;
  font-family: 宋体;
  font-weight: 600;
}

.information-content>>>.item .el-form-item__label {
  font-size: 1vh;
}

.information-content>>>.el-input-group__append,
.el-input-group__prepend {
  padding: 0 7px;
}
</style>
<style>
.el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #48adff;
}

.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 32px;
}

.el-table__body tr,
.el-table__body td {
  padding: 0;
  height: 27px;
}

.el-input__inner {
  height: 26px;
  border-radius: 0px;
  font-size: 1vh;
  color: #A5A5A5;
}

.el-table .cell {
  padding-left: 0px;
  padding-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/designtoolpages/TheMain.vue